// extracted by mini-css-extract-plugin
export default {"carousel":"MxZpOK","card":"VFqY4u","mask":"OVeHPd","quote":"YeSYbR"};